import type { CommitedClubDto } from "@/modules/boxDashboard/gateway/boxDashboardApiDto"
import type { HUImage } from "@/modules/types/imageTypes"

export class CommitedClubMemberEntity {
  constructor(
    public readonly id: string,
    public readonly firstname: string | null,
    public readonly lastname: string | null,
    public readonly sessionsCount: number,
    public readonly avatar: HUImage | null,
  ) {}

  static fromDto(dto: CommitedClubDto) {
    return new CommitedClubMemberEntity(
      dto.boxMember.id,
      dto.boxMember.firstname,
      dto.boxMember.lastname,
      dto.participationCount,
      dto.boxMember.avatar,
    )
  }

  get displayName(): string {
    return `${this.firstname ?? ""} ${this.lastname ?? ""}`
  }

  get shortName(): string {
    return `${this.firstname ?? ""} ${this.lastname?.charAt(0) ?? ""}`
  }
}
